Vendd.Scripts.load(function () {
    var $wrapper = $('.countdown-widget');

    if ($wrapper.length < 1)
        return;

    $wrapper.each(function () {
        var wrapper = $(this);

        var target = $('.countdown-configuration', wrapper).data('target');
        var structure = $('.countdown-configuration', wrapper).data('structure'); 
        
        if (!target || !structure) return;

        $('.countdown', wrapper).countdown(target, function (event) {
            $(this).html(event.strftime(structure));
        });

    });
    
});

